export default __webpack_public_path__ + "locales/cs/ConnectDialog.json?hash=9b15012659d50c18e79f3ebf28b8c39f";